/**
 * A function to create a log object for the 'mediaManagerBoardAction' event (evid: 686)
 *
 * Event description: User clicks onboard action on My boards tab
 *
 * @param {mediaManagerBoardActionParams} params - The parameters for this event
 * @property {string} boardId - board_id or favorites
 * @property {string} clickOrigin - right_side_panel / menu / empty_state / board (for copy click)
 * @property {string} context - context
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid - site
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - session id
 * @property {string} source - who opened
 * @property {string} tabName - tab_name
 * @property {string} target - edit / add_files / delete / copy /  upload_cover
 * @property {GUID} teammate_id - teammate_id
 * @return {LogObject<mediaManagerBoardActionParams>} LogObject<mediaManagerBoardActionParams>
 */
export function mediaManagerBoardAction(params) {
    return { evid: 686, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaEditorPanelUploadButtonClick' event (evid: 661)
 *
 * Event description: User clicks on Upload and Import button on Media Editor Panel
 *
 * @param {mediaEditorPanelUploadButtonClickParams} params - The parameters for this event
 * @property {string} button - main / facebook / instagram etc
 * @property {string} dm_version - .
 * @property {string} editor_version - .
 * @property {string} editor_working_mode - editor_working_mode
 * @property {GUID} esi - editor session id
 * @property {string} focused_page_id - focused_page_id
 * @property {string} js_heap_size_limit - []
 * @property {GUID} msid - site
 * @property {string} multilingual - multilingual
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} total_js_heap_size - []
 * @property {number} ts - ts
 * @property {string} used_js_heap_size - []
 * @property {string} viewerName - viewer_name
 * @property {string} viewmode - viewmode
 * @return {LogObject<mediaEditorPanelUploadButtonClickParams>} LogObject<mediaEditorPanelUploadButtonClickParams>
 */
export function mediaEditorPanelUploadButtonClick(params) {
    return { evid: 661, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerFavoritesButtonsClick' event (evid: 618)
 *
 * Event description: User clicks on stars on files or other buttons to add or remove files from  favorite
 *
 * @param {mediaManagerFavoritesButtonsClickParams} params - The parameters for this event
 * @property {string} clickOrigin - more_actions_top_right / file / batch / folder / more_actions_right_middle/ add_to_fav_right_middle
 * @property {string} layout - layout
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @property {string} target - remove / add
 * @return {LogObject<mediaManagerFavoritesButtonsClickParams>} LogObject<mediaManagerFavoritesButtonsClickParams>
 */
export function mediaManagerFavoritesButtonsClick(params) {
    return { evid: 618, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerCreateFolderActions' event (evid: 611)
 *
 * Event description: Actions related to creating folder
 *
 * @param {mediaManagerCreateFolderActionsParams} params - The parameters for this event
 * @property {string} clickOrigin - actions / move_to / top_right / more_info / top_center
 * @property {string} fileId - folder id after creation
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @property {string} target - started / created (after it succeed)
 * @return {LogObject<mediaManagerCreateFolderActionsParams>} LogObject<mediaManagerCreateFolderActionsParams>
 */
export function mediaManagerCreateFolderActions(params) {
    return { evid: 611, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'addMediaAccountConnectClick' event (evid: 627)
 *
 * Event description: User connects social account
 *
 * @param {addMediaAccountConnectClickParams} params - The parameters for this event
 * @property {string} layout - layout
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - tabName
 * @property {string} target - facebook / drive / dropbox / wix_sites / url / vimeo / etc
 * @return {LogObject<addMediaAccountConnectClickParams>} LogObject<addMediaAccountConnectClickParams>
 */
export function addMediaAccountConnectClick(params) {
    return { evid: 627, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerStorageStatusOpenMm' event (evid: 812)
 *
 * Event description: Data about the site's storage status: used storage, storage limit. Shoot every time when mm opened.
 *
 * @param {mediaManagerStorageStatusOpenMmParams} params - The parameters for this event
 * @property {string} context - image / video / doc etc
 * @property {string} layout - layout
 * @property {string} mmgrVersion - MM version on load
 * @property {GUID} msid - .
 * @property {string} origin - .
 * @property {string} pageName - Media Manager / Storage Manager
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - .
 * @property {string} source - .
 * @property {number} storage_limit - site storage limit in current premium package
 * @property {string} storage_status - not_exceeding, about_to_exceed, exceed
 * @property {string} tabName - the tab the manager was opened
 * @property {number} used_storage - amount of storage used in site
 * @return {LogObject<mediaManagerStorageStatusOpenMmParams>} LogObject<mediaManagerStorageStatusOpenMmParams>
 */
export function mediaManagerStorageStatusOpenMm(params) {
    return { evid: 812, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'actionsMenuClick' event (evid: 641)
 *
 * Event description: User clicks on something in the actions menu
 *
 * @param {actionsMenuClickParams} params - The parameters for this event
 * @property {string} actionName - add_to_favorites / rename / crop_edit / preview / show_info / move_to / share_video etc
 * @property {string} clickOrigin - dots / right_click / more_actions_top_right / more_actions_right_middle
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file or folder id
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - image / video / audio / doc / mixed / null
 * @property {GUID} msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin
 * @property {string} pageName - mmgr / Storage Manager
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites etc.
 * @property {string} target - file / batch / file_in_preview_mode / folder / empty / breadcrumbs
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<actionsMenuClickParams>} LogObject<actionsMenuClickParams>
 */
export function actionsMenuClick(params) {
    return { evid: 641, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'addMediaMediaSourceSelected' event (evid: 622)
 *
 * Event description: User clicks on  upload / facebook / drive / dropbox / wix_sites / url  to start upload media from that source
 *
 * @param {addMediaMediaSourceSelectedParams} params - The parameters for this event
 * @property {string} clickOrigin - full_size / minimized / drag_and_drop / import_files_tabs / upload_files_to_folder
 * @property {string} layout - layout
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - tabName
 * @property {string} target - upload / facebook / drive / dropbox / wix_sites / url / upload_drag_and_drop / vimeo / etc
 * @return {LogObject<addMediaMediaSourceSelectedParams>} LogObject<addMediaMediaSourceSelectedParams>
 */
export function addMediaMediaSourceSelected(params) {
    return { evid: 622, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerStorageUpdated' event (evid: 813)
 *
 * Event description: Shoot every time when the storage usage or limit is changed - file uploaded /deleted/ duplicated/ premium plan bought/etc.                              Note: for upgrades, the event will shoot only if the MM was open.
 *
 * @param {mediaManagerStorageUpdatedParams} params - The parameters for this event
 * @property {string} action_type - upload, copy, delete, restore, premium upgrade, premium cancel
 * @property {string} context - image / video / doc etc
 * @property {string} layout - layout
 * @property {string} mmgrVersion - MM version on load
 * @property {GUID} msid - msid
 * @property {string} origin - media manager, BM - video maker, BM - wix video, BM - wix music, premium
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - sessionID
 * @property {string} source - upload, copy, edit and duplicate, edit video, shutterstock purchase, upgrade, delete
 * @property {number} storage_limit - maximum storage available for current package
 * @property {number} storage_percent - percent of storage in use: used storage / storage limit
 * @property {string} storage_status - not_exceeding,  about_to_exceed, exceed
 * @property {string} tabName - the tab the manager was opened
 * @property {string} update - update after usage or upgrade
 * @property {number} used_storage - current used storage
 * @return {LogObject<mediaManagerStorageUpdatedParams>} LogObject<mediaManagerStorageUpdatedParams>
 */
export function mediaManagerStorageUpdated(params) {
    return { evid: 813, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'addMediaUrlParsingCompleted' event (evid: 630)
 *
 * Event description: Import from url - url parsing finish
 *
 * @param {addMediaUrlParsingCompletedParams} params - The parameters for this event
 * @property {string} layout - layout
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} siteUrl - from which site
 * @property {string} source
 * @property {boolean} success - true / false
 * @property {string} tabName - tabName
 * @return {LogObject<addMediaUrlParsingCompletedParams>} LogObject<addMediaUrlParsingCompletedParams>
 */
export function addMediaUrlParsingCompleted(params) {
    return { evid: 630, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerAddToBoardFinished' event (evid: 683)
 *
 * Event description: File added or removed from Board
 *
 * @param {mediaManagerAddToBoardFinishedParams} params - The parameters for this event
 * @property {string} boardId - board_id or favorites
 * @property {string} clickOrigin - click_origin
 * @property {string} context - context
 * @property {string} fileFormat - .
 * @property {string} fileId - file id or json
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / public / shutter
 * @property {string} mediaType - image / video / audio / doc
 * @property {GUID} msid - site
 * @property {string} name - .
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - session id
 * @property {string} source - who opened
 * @property {string} tabName - tab_name
 * @property {string} target - add / remove
 * @return {LogObject<mediaManagerAddToBoardFinishedParams>} LogObject<mediaManagerAddToBoardFinishedParams>
 */
export function mediaManagerAddToBoardFinished(params) {
    return { evid: 683, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'searchAndFiltersFilterClick' event (evid: 654)
 *
 * Event description: Users clicks on filter to see the filter dropdown
 *
 * @param {searchAndFiltersFilterClickParams} params - The parameters for this event
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @property {string} target - media_type / type / categories / orientation / color
 * @return {LogObject<searchAndFiltersFilterClickParams>} LogObject<searchAndFiltersFilterClickParams>
 */
export function searchAndFiltersFilterClick(params) {
    return { evid: 654, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'addMediaFinished' event (evid: 625)
 *
 * Event description: Media upload finished (send after processing completed)
 *
 * @param {addMediaFinishedParams} params - The parameters for this event
 * @property {number} auto_resumed - count how many times (in current correlation_id) upload was resumed automatically
 * @property {boolean} batch - several files in one import
 * @property {string} batchId - batch id
 * @property {number} batchSize - amount of files
 * @property {string} clickOrigin - full_size
 * @property {string} correlationId - id to find one upload process
 * @property {string} errorKey - error key from server, e.g "wmp_error.*"
 * @property {string} errorReason - errors
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file id
 * @property {string} fileOrigin - fileOrigin
 * @property {number} fileSize - file size in KB
 * @property {string} fileType - file_type
 * @property {boolean} is_resumable - is download resume available for this file
 * @property {boolean} isTags - default tags
 * @property {string} layout - layout
 * @property {number} loadingTime - loading time
 * @property {number} manual_resumed - count how many times upload was resumed manually
 * @property {string} mediaOrigin - media_origin
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid
 * @property {string} name - name
 * @property {string} origin
 * @property {string} parent_correlation_id - in case of uploading multiple files, send an ID that will indicate the overall upload process of all files
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {boolean} success - true / false
 * @property {string} tabName - tab name
 * @property {string} target - upload / facebook / drive / dropbox / wix_sites / url / upload_drag_and_drop / vimeo / etc
 * @property {string} videoSession - videoSession
 * @return {LogObject<addMediaFinishedParams>} LogObject<addMediaFinishedParams>
 */
export function addMediaFinished(params) {
    return { evid: 625, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerFeedbackTrigger' event (evid: 657)
 *
 * Event description: MM request Feedback if to show it (checking exposure etc)
 *
 * @param {mediaManagerFeedbackTriggerParams} params - The parameters for this event
 * @property {string} categoryId - Feedback category (face_detection)
 * @property {string} feedbackLayout - Feedback layout (regions-recognition)
 * @property {string} fileId - file id
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} imageUrl - Feedback image
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid - site
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session_id
 * @property {string} source - source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @property {string} trigger - Feedback trigger (upload)
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<mediaManagerFeedbackTriggerParams>} LogObject<mediaManagerFeedbackTriggerParams>
 */
export function mediaManagerFeedbackTrigger(params) {
    return { evid: 657, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'storageManagerBottonClick' event (evid: 821)
 *
 * Event description: User clicks on the 'Manage Storage' button
 *
 * @param {storageManagerBottonClickParams} params - The parameters for this event
 * @property {string} buttonOrigin - where was the button located
 * @property {GUID} msid - .
 * @property {string} origin - .
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - .
 * @property {string} source - .
 * @property {string} storage_status - not_exceeding,  about_to_exceed, exceed
 * @return {LogObject<storageManagerBottonClickParams>} LogObject<storageManagerBottonClickParams>
 */
export function storageManagerBottonClick(params) {
    return { evid: 821, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerFeatureOnboarding' event (evid: 689)
 *
 * Event description: MM onboarding page open to user
 *
 * @param {mediaManagerFeatureOnboardingParams} params - The parameters for this event
 * @property {string} actionName - popup_shown / close_click / ok_click
 * @property {string} feature - welcome_boards, how_it_works_boards etc
 * @property {string} layout - layout
 * @property {GUID} msid - msid
 * @property {string} origin - origin
 * @property {string} pageType - cnt of users sites - new/existing_one_site/existing_multiple_site
 * @property {string} publicMediaRoot - .
 * @property {string} sessionId - sessionId
 * @property {string} source - source
 * @property {string} tabName - tab_name
 * @return {LogObject<mediaManagerFeatureOnboardingParams>} LogObject<mediaManagerFeatureOnboardingParams>
 */
export function mediaManagerFeatureOnboarding(params) {
    return { evid: 689, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerTrashButtonsClick' event (evid: 616)
 *
 * Event description: User clicks on buttons on Trash tab (Empty trash / restore / delete forever)
 *
 * @param {mediaManagerTrashButtonsClickParams} params - The parameters for this event
 * @property {string} layout - layout
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - tabName
 * @property {string} target - empty_trash / restore / delete_forever
 * @return {LogObject<mediaManagerTrashButtonsClickParams>} LogObject<mediaManagerTrashButtonsClickParams>
 */
export function mediaManagerTrashButtonsClick(params) {
    return { evid: 616, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'searchAndFiltersStarted' event (evid: 650)
 *
 * Event description: Shoot on search start (click or enter) or filter apply click
 *
 * @param {searchAndFiltersStartedParams} params - The parameters for this event
 * @property {string} clickOrigin - search / filter_categories / filter_color / filter_media_type / filter_orientation / search_from_related / tag
 * @property {string} context - context
 * @property {string} correlationId - correlation id
 * @property {string} filterCategory - category that was filtered when user use search/filter
 * @property {string} filterColor - the color user filtered
 * @property {string} filterOrientation - orientation that was filtered when user use search/filter
 * @property {string} filterPricing - price
 * @property {string} filterType - type that was filtered when user use search/filter
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} pageName - Media Manager / Storage Manager
 * @property {string} publicMediaRoot
 * @property {GUID} search_id - Search ID
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock / storage_manager_site_files / storage_manager_trash
 * @property {string} target - what does user search for (term, phrase, word) or settings from filter (ex. media_type = video, then video)
 * @return {LogObject<searchAndFiltersStartedParams>} LogObject<searchAndFiltersStartedParams>
 */
export function searchAndFiltersStarted(params) {
    return { evid: 650, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'homeDiscoverMediaClick' event (evid: 673)
 *
 * Event description: User clicks on a Discover Media section (media home tab)
 *
 * @param {homeDiscoverMediaClickParams} params - The parameters for this event
 * @property {string} button_name - nav_right / nav_left / images / videos etc
 * @property {string} context - public media root
 * @property {string} layout - layout
 * @property {GUID} msid - site
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session_id
 * @property {string} source - who open MM (stores, bookings etc.)
 * @property {string} tabName - tab_name
 * @return {LogObject<homeDiscoverMediaClickParams>} LogObject<homeDiscoverMediaClickParams>
 */
export function homeDiscoverMediaClick(params) {
    return { evid: 673, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'actionsOpenClick' event (evid: 640)
 *
 * Event description: User clicks to open actions menu
 *
 * @param {actionsOpenClickParams} params - The parameters for this event
 * @property {string} clickOrigin - dots / right_click / more_actions_top_right / more_actions_right_middle
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file or folder id
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - image / video / audio / doc / mixed / null
 * @property {GUID} msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites etc.
 * @property {string} target - file / batch / file_in_preview_mode / folder / empty / breadcrumbs
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<actionsOpenClickParams>} LogObject<actionsOpenClickParams>
 */
export function actionsOpenClick(params) {
    return { evid: 640, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'actionsDone' event (evid: 642)
 *
 * Event description: After successful action finish (ex rename, move)
 *
 * @param {actionsDoneParams} params - The parameters for this event
 * @property {string} actionName - rename / move_to / paste / drag_and_drop / restore / delete_forever / download
 * @property {string} clickOrigin - dots / right_click / more_actions_top_right /more_actions_right_middle/ add_to_fav_right_middle/ top_center / more_info
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file or folder id
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - image / video / audio / doc / mixed / null
 * @property {GUID} msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin
 * @property {string} pageName - mmgr / Storage Manager
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites etc.
 * @property {string} target - file / batch / file_in_preview_mode / folder / empty / breadcrumbs / panel_info
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<actionsDoneParams>} LogObject<actionsDoneParams>
 */
export function actionsDone(params) {
    return { evid: 642, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerCreateBoardClick' event (evid: 687)
 *
 * Event description: User clicks on Create new board on My boards tab
 *
 * @param {mediaManagerCreateBoardClickParams} params - The parameters for this event
 * @property {string} clickOrigin - right_side_panel / menu / empty_state / board (for copy click)
 * @property {string} context - context
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid - site
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - session id
 * @property {string} source - who opened
 * @property {string} tabName - tab_name
 * @property {GUID} teammate_id - teammate_id
 * @return {LogObject<mediaManagerCreateBoardClickParams>} LogObject<mediaManagerCreateBoardClickParams>
 */
export function mediaManagerCreateBoardClick(params) {
    return { evid: 687, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerOpened' event (evid: 601)
 *
 * Event description: Shoot every time when mm opened (loaded from scratch - is first=true or open from hidden is first=false).
 *
 * @param {mediaManagerOpenedParams} params - The parameters for this event
 * @property {string} context - image / video / doc etc
 * @property {boolean} isFirst - first time per session
 * @property {string} layout - layout
 * @property {number} loadingTime - loading_time
 * @property {string} mmgrVersion - MM version on load
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - the tab the manager was opened
 * @property {GUID} teammate_id - teammate_id
 * @return {LogObject<mediaManagerOpenedParams>} LogObject<mediaManagerOpenedParams>
 */
export function mediaManagerOpened(params) {
    return { evid: 601, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerSortClick' event (evid: 604)
 *
 * Event description: Click on sorting icon to open dropdown
 *
 * @param {mediaManagerSortClickParams} params - The parameters for this event
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @return {LogObject<mediaManagerSortClickParams>} LogObject<mediaManagerSortClickParams>
 */
export function mediaManagerSortClick(params) {
    return { evid: 604, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerBoardPopUpClick' event (evid: 684)
 *
 * Event description: User clicks on Create New board pop up
 *
 * @param {mediaManagerBoardPopUpClickParams} params - The parameters for this event
 * @property {string} context - context
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid - site
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - session id
 * @property {string} source - who opened
 * @property {string} tabName - tab_name
 * @property {string} target - create / cancel / close / edit
 * @return {LogObject<mediaManagerBoardPopUpClickParams>} LogObject<mediaManagerBoardPopUpClickParams>
 */
export function mediaManagerBoardPopUpClick(params) {
    return { evid: 684, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerBoardClick' event (evid: 681)
 *
 * Event description: User clicks on Add to Board icon
 *
 * @param {mediaManagerBoardClickParams} params - The parameters for this event
 * @property {string} clickOrigin - file / more_info
 * @property {string} context - context
 * @property {string} fileFormat - .
 * @property {string} fileId - file id or json
 * @property {string} fileOrigin - .
 * @property {string} fileType - .
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - .
 * @property {GUID} msid - site
 * @property {string} name - .
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - session id
 * @property {string} source - who opened
 * @property {string} tabName - tab_name
 * @property {string} target - add / remove
 * @return {LogObject<mediaManagerBoardClickParams>} LogObject<mediaManagerBoardClickParams>
 */
export function mediaManagerBoardClick(params) {
    return { evid: 681, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerToastAppear' event (evid: 810)
 *
 * Event description: A toast is shown
 *
 * @param {mediaManagerToastAppearParams} params - The parameters for this event
 * @property {string} context - image / video / doc etc
 * @property {boolean} isFirst - first time per session
 * @property {string} layout
 * @property {string} mmgrVersion - MM version on load
 * @property {GUID} msid - .
 * @property {string} origin - .
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - .
 * @property {string} source - .
 * @property {string} tabName - the tab the manager was opened
 * @property {string} toastName - storage_upgraded,  about_to_exceed,  exceed,  storage_is_full_popup, exceed_no_upgrade_option, exceed_after_upload
 * @property {string} type - storage
 * @property {boolean} upgrade_available - true / false
 * @return {LogObject<mediaManagerToastAppearParams>} LogObject<mediaManagerToastAppearParams>
 */
export function mediaManagerToastAppear(params) {
    return { evid: 810, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerBoardSaved' event (evid: 685)
 *
 * Event description: Board created / updated
 *
 * @param {mediaManagerBoardSavedParams} params - The parameters for this event
 * @property {string} availability - this_site / all_sites
 * @property {string} boardId - board_id or favorites
 * @property {string} clickOrigin - click_origin
 * @property {string} context - context
 * @property {boolean} coverAdded - t / f
 * @property {boolean} isNew - t for created, f  for changes
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid - site
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - session id
 * @property {string} source - who opened
 * @property {string} tabName - tab_name
 * @property {string} teamAvailability - on / off
 * @return {LogObject<mediaManagerBoardSavedParams>} LogObject<mediaManagerBoardSavedParams>
 */
export function mediaManagerBoardSaved(params) {
    return { evid: 685, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerImageEditToolClick' event (evid: 644)
 *
 * Event description: User click on editing tools in the info panel
 *
 * @param {mediaManagerImageEditToolClickParams} params - The parameters for this event
 * @property {string} clickOrigin - more_info / top_panel / preview_in_info_panel / image_thumbnails
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file id (users file, free or shutter, should have valid id)
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {GUID} msid - msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session_id
 * @property {string} source - source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @property {string} target - crop/adjust/background
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<mediaManagerImageEditToolClickParams>} LogObject<mediaManagerImageEditToolClickParams>
 */
export function mediaManagerImageEditToolClick(params) {
    return { evid: 644, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerSortChanged' event (evid: 605)
 *
 * Event description: Sorting changed after click on sorting icon
 *
 * @param {mediaManagerSortChangedParams} params - The parameters for this event
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} previousSelection - ast_modified / oldest_first / a_z / z_a
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @property {string} target - last_modified / oldest_first / a_z / z_a
 * @return {LogObject<mediaManagerSortChangedParams>} LogObject<mediaManagerSortChangedParams>
 */
export function mediaManagerSortChanged(params) {
    return { evid: 605, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'adobeOpenClick' event (evid: 815)
 *
 * Event description: User click on edit with adobe express.
 *
 * @param {adobeOpenClickParams} params - The parameters for this event
 * @property {string} fileFormat - png, jpeg
 * @property {string} fileOrigin - wix_media / unsplash / shutterstock / upload / import
 * @property {string} mediaRoot - photos / videos / background ...
 * @property {string} mediaType - extension
 * @property {GUID} msid - site
 * @property {string} origin - from what platform it was accessed (Editor / Studio)
 * @property {string} publicMediaRoot
 * @property {string} sessionId - media studio session id
 * @property {string} source - entry point (actions panel / actions menu)
 * @return {LogObject<adobeOpenClickParams>} LogObject<adobeOpenClickParams>
 */
export function adobeOpenClick(params) {
    return { evid: 815, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'homeEditingToolsClick' event (evid: 672)
 *
 * Event description: User clicks on an Open button to entry Video Maker or Photo Studio  section (media home tab)
 *
 * @param {homeEditingToolsClickParams} params - The parameters for this event
 * @property {string} button_name - video_maker_open / photo_studio_open
 * @property {string} layout - layout
 * @property {GUID} msid - site
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session_id
 * @property {string} source - who open MM (stores, bookings etc.)
 * @property {string} tabName - tab_name
 * @return {LogObject<homeEditingToolsClickParams>} LogObject<homeEditingToolsClickParams>
 */
export function homeEditingToolsClick(params) {
    return { evid: 672, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerUserMigrated' event (evid: 800)
 *
 * Event description: Shoot after users migrated to MM6, needed for A/B test (profile attribute filter)
 *
 * @param {mediaManagerUserMigratedParams} params - The parameters for this event
 * @property {string} migration_status - on/off
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @return {LogObject<mediaManagerUserMigratedParams>} LogObject<mediaManagerUserMigratedParams>
 */
export function mediaManagerUserMigrated(params) {
    return { evid: 800, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerNextPageRender' event (evid: 670)
 *
 * Event description: Event for performance measuring of nextPageRender
 *
 * @param {mediaManagerNextPageRenderParams} params - The parameters for this event
 * @property {string} context - image / video / doc etc
 * @property {string} correlationId - correlation_id to combine with 110
 * @property {string} layout - layout
 * @property {number} loadingTime - loading_time
 * @property {GUID} msid - msid
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session_id
 * @property {string} source - source
 * @property {string} tabName - tab name
 * @property {GUID} teammate_id - teammate_id
 * @return {LogObject<mediaManagerNextPageRenderParams>} LogObject<mediaManagerNextPageRenderParams>
 */
export function mediaManagerNextPageRender(params) {
    return { evid: 670, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'addMediaStarted' event (evid: 624)
 *
 * Event description: Media upload started
 *
 * @param {addMediaStartedParams} params - The parameters for this event
 * @property {boolean} batch - several files in one import
 * @property {string} batchId - batch id
 * @property {number} batchSize - amount of files
 * @property {string} clickOrigin - full_size
 * @property {string} correlationId - id to find one upload process
 * @property {string} fileFormat - file extension
 * @property {number} fileSize - file size in KB
 * @property {string} layout - layout
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} parent_correlation_id - in case of uploading multiple files, send an ID that will indicate the overall upload process of all files
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - tab name
 * @property {string} target - upload / facebook / drive / dropbox / wix_sites / url / upload_drag_and_drop / vimeo / etc
 * @property {string} uploadType - auto_resumed / user_resumed / upload
 * @return {LogObject<addMediaStartedParams>} LogObject<addMediaStartedParams>
 */
export function addMediaStarted(params) {
    return { evid: 624, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaPurchaseThankYouPageOpened' event (evid: 690)
 *
 * Event description: mediaManager.ThankYouPage.loaded after successful media item purchase
 *
 * @param {mediaPurchaseThankYouPageOpenedParams} params - The parameters for this event
 * @property {string} fileId - shutterstock file id or WIX file_id
 * @property {string} mediaProducer - Shutterstock or Wix Stock
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid - msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot - .
 * @property {string} sessionId - session_id
 * @property {string} source - .
 * @property {string} tab - MM - ST tab / MM - MH tab / MM - WIX tab / EMP - ST section / EMP - recommended / EMP - WIX section
 * @return {LogObject<mediaPurchaseThankYouPageOpenedParams>} LogObject<mediaPurchaseThankYouPageOpenedParams>
 */
export function mediaPurchaseThankYouPageOpened(params) {
    return { evid: 690, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaEditorPanelSearchCancelClick' event (evid: 663)
 *
 * Event description: User clicks on (x) to cancel the search
 *
 * @param {mediaEditorPanelSearchCancelClickParams} params - The parameters for this event
 * @property {string} editor_version - .
 * @property {string} editor_working_mode - editor_working_mode
 * @property {GUID} esi - editor session id
 * @property {string} focused_page_id - focused_page_id
 * @property {string} js_heap_size_limit - []
 * @property {GUID} msid - site
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session_id
 * @property {string} source - source
 * @property {string} target - search term
 * @property {string} total_js_heap_size - []
 * @property {number} ts - ts
 * @property {string} used_js_heap_size - []
 * @property {string} viewerName - viewer_name
 * @property {string} viewmode - viewmode
 * @return {LogObject<mediaEditorPanelSearchCancelClickParams>} LogObject<mediaEditorPanelSearchCancelClickParams>
 */
export function mediaEditorPanelSearchCancelClick(params) {
    return { evid: 663, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerPanelFileInfoCreateVideoClick' event (evid: 668)
 *
 * Event description: User clicks on Create Video from panel (More Info section)
 *
 * @param {mediaManagerPanelFileInfoCreateVideoClickParams} params - The parameters for this event
 * @property {string} actionName - create_video / re-edit / share_video
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file or folder id
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - image / video / audio / doc / mixed / null
 * @property {GUID} msid - msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session_id
 * @property {string} source - source
 * @property {string} tabName - site_files / my_favorites etc.
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<mediaManagerPanelFileInfoCreateVideoClickParams>} LogObject<mediaManagerPanelFileInfoCreateVideoClickParams>
 */
export function mediaManagerPanelFileInfoCreateVideoClick(params) {
    return { evid: 668, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaBeUploadFail' event (evid: 802)
 *
 * Event description: Media upload failed
 *
 * @param {mediaBeUploadFailParams} params - The parameters for this event
 * @property {number} auto_resumed - count how many times (in current correlation_id) upload was resumed automatically
 * @property {string} channels - audio channels
 * @property {string} correlationId - id to find one upload process
 * @property {string} displayAspectRatio - 16:9
 * @property {string} errorKey - error key from server, e.g "wmp_error.*"
 * @property {string} errorReason - errors
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file id
 * @property {number} fileSize - file size in bytes
 * @property {string} fileUrl - Full file URL
 * @property {string} fps - fps
 * @property {number} height - height
 * @property {string} httpErrorCode - http_error_code
 * @property {number} manual_resumed - count how many times (in current correlation_id) upload was resumed manually
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {string} mimeType - image/png
 * @property {GUID} msid - msid
 * @property {string} orientation - orientation
 * @property {string} origin - Application initiating the upload - MMgr, PStudio, Mobile etc
 * @property {string} originalFileName - Original uploaded file name
 * @property {string} parent_correlation_id - in case of uploading multiple files, send an ID that will indicate the overall upload process of all files
 * @property {string} publicMediaRoot
 * @property {string} sampleRate - sample rate (audio only)
 * @property {string} sessionId
 * @property {string} source - Source of image - upload from computer, mobile, import from FB, edited image, video maker etc
 * @property {string} sourceUrl - url for VM videos
 * @property {string} stage - upload stage (upload, transcode etc.)
 * @property {string} tags - system tags
 * @property {string} target - upload / facebook / drive / dropbox / wix_sites / url / upload_drag_and_drop / vimeo / etc
 * @property {number} videoDuration - video duration in ms
 * @property {number} width - width
 * @return {LogObject<mediaBeUploadFailParams>} LogObject<mediaBeUploadFailParams>
 */
export function mediaBeUploadFail(params) {
    return { evid: 802, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerFileChosen' event (evid: 608)
 *
 * Event description: Click on file choose button
 * (target = select for file choose and target = buy for shutterstock)
 *
 * @param {mediaManagerFileChosenParams} params - The parameters for this event
 * @property {string} category - active category at that moment: all, animals, abstract etc
 * @property {string} categoryId - for free from wix or shutter
 * @property {number} clicked_file_index - Index of the image clicked appeared in layout
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file id (users file, free or shutter, should have valid id)
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} fileUrl - file_url
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / public / shutter
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} orientation - active filter on orientation
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {GUID} search_id - Search ID
 * @property {string} searchTerm - current search term or NULL if no search performed
 * @property {number} section_index - The section index the file was selected from
 * @property {string} section_name - The section selected from out of section appeared in search: Site Files / Media From Wix / Unsplash / Shutterstock
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @property {string} target - select / buy
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<mediaManagerFileChosenParams>} LogObject<mediaManagerFileChosenParams>
 */
export function mediaManagerFileChosen(params) {
    return { evid: 608, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'navigationButtonClick' event (evid: 693)
 *
 * Event description: NavigationButton.click
 *
 * @param {navigationButtonClickParams} params - The parameters for this event
 * @property {string} button_name - nav_left / nav_right
 * @property {string} layout - .
 * @property {GUID} msid - site
 * @property {string} origin - origin
 * @property {string} publicMediaRoot - .
 * @property {string} sessionId - session_id
 * @property {string} source - who open MM (stores, bookings etc.)
 * @property {string} tabName - tabName
 * @property {string} target - image_unsplash /  image_shutterstock /               social_icons_public / etc
 * @return {LogObject<navigationButtonClickParams>} LogObject<navigationButtonClickParams>
 */
export function navigationButtonClick(params) {
    return { evid: 693, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerTryAgainClick' event (evid: 665)
 *
 * Event description: User clicks on Try again button on the error screen
 *
 * @param {mediaManagerTryAgainClickParams} params - The parameters for this event
 * @property {string} context - context
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} pageName - Media Manager / Storage Manager
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock / trash / storage_manager_site_files / storage_manager_trash
 * @return {LogObject<mediaManagerTryAgainClickParams>} LogObject<mediaManagerTryAgainClickParams>
 */
export function mediaManagerTryAgainClick(params) {
    return { evid: 665, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'addMediaAccountDisconnectClick' event (evid: 628)
 *
 * Event description: User clicks and disconnects social account
 *
 * @param {addMediaAccountDisconnectClickParams} params - The parameters for this event
 * @property {string} layout - layout
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - tabName
 * @property {string} target - facebook / drive / dropbox / wix_sites / url / vimeo / etc
 * @return {LogObject<addMediaAccountDisconnectClickParams>} LogObject<addMediaAccountDisconnectClickParams>
 */
export function addMediaAccountDisconnectClick(params) {
    return { evid: 628, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'recommendedButtonClick' event (evid: 671)
 *
 * Event description: User clicks on a button in Recommended section (in editor panel or media manager)
 *
 * @param {recommendedButtonClickParams} params - The parameters for this event
 * @property {string} button_name - apply / see_all / three_dots / do_this_later / dont_show_again / show_more / settings / info / nav_left / nav_right    /feedback_apply / feedback_cancel / feedback_close
 * @property {string} editor_working_mode - editor_working_mode
 * @property {GUID} esi - editor session id
 * @property {string} jsHeapSizeLimit - []
 * @property {GUID} msid - site
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} selection - string with all user selection (art, nature etc.)
 * @property {string} sessionId - session_id
 * @property {string} source
 * @property {string} target - editor_panel / media_manager
 * @property {string} totalJsHeapSize - []
 * @property {number} ts - ts
 * @property {string} usedJsHeapSize - []
 * @property {string} viewmode - viewmode
 * @return {LogObject<recommendedButtonClickParams>} LogObject<recommendedButtonClickParams>
 */
export function recommendedButtonClick(params) {
    return { evid: 671, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaEditorPanelSearchStart' event (evid: 658)
 *
 * Event description: Search in Media Editor Panel started
 *
 * @param {mediaEditorPanelSearchStartParams} params - The parameters for this event
 * @property {string} dm_version - .
 * @property {string} editor_version - .
 * @property {string} editor_working_mode - editor_working_mode
 * @property {GUID} esi - editor session id
 * @property {string} focused_page_id - focused_page_id
 * @property {string} js_heap_size_limit - []
 * @property {GUID} msid - site
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} target - search term
 * @property {string} total_js_heap_size - []
 * @property {number} ts - ts
 * @property {string} used_js_heap_size - []
 * @property {string} viewerName - viewer_name
 * @property {string} viewmode - viewmode
 * @return {LogObject<mediaEditorPanelSearchStartParams>} LogObject<mediaEditorPanelSearchStartParams>
 */
export function mediaEditorPanelSearchStart(params) {
    return { evid: 658, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaBeUploadFinish' event (evid: 801)
 *
 * Event description: BE event for media upload
 *
 * @param {mediaBeUploadFinishParams} params - The parameters for this event
 * @property {string} appId - APP id (for the server-to-server uploads)
 * @property {number} auto_resumed - count how many times (in current correlation_id) upload was resumed automatically
 * @property {boolean} batch - several files in one import
 * @property {string} batchId - batch id
 * @property {number} batchSize - amount of files
 * @property {number} bitrate - bitrate (audio/video)
 * @property {string} channels - audio channels
 * @property {string} clickOrigin - full_size
 * @property {string} colorPalette - [{"b":243,"g":235,"r":196}] etc.
 * @property {string} correlationId - id to find one upload process
 * @property {string} displayAspectRatio - 16:9
 * @property {string} editHistory - edit_history
 * @property {string} enLabels - ["Hairstyle","Blazer","Formal wear","Gentleman"]
 * @property {string} explicitContent - [{"name":"adult","likelihood":"LIKELY"}, {"name":"racy","likelihood":"VERY_LIKELY"}]
 * @property {string} faces - [{"confidence":0.9904465675354004,"height":401,"width":286,"x":584,"y":123}]
 * @property {string} fileFormat - file extension
 * @property {string} fileId - Private Media file ID
 * @property {number} fileSize - file size in bytes
 * @property {string} fileUrl - Full file URL
 * @property {string} fontName - font name
 * @property {string} fps - fps
 * @property {number} height - height
 * @property {string} labelsDetails - [{"description":"Blue","score":0.94453025}] etc.
 * @property {number} loadingTime - loading time
 * @property {string} localizedLabels - labels in user language (null if en)
 * @property {number} manual_resumed - count how many times (in current correlation_id
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {string} mimeType - image/png
 * @property {GUID} msid - msid
 * @property {string} ns - Namespace
 * @property {string} orientation - orientation
 * @property {string} origin - Application initiating the upload - MMgr, PStudio, Mobile etc
 * @property {string} originalFileName - Original uploaded file name
 * @property {string} parent_correlation_id - in case of uploading multiple files, send an ID that will indicate the overall upload process of all files
 * @property {string} parentFolder - Folder name the file was uploaded to
 * @property {string} prominentColor - [{"b":241,"g":234,"r":198}]
 * @property {string} publicMediaRoot
 * @property {string} rotation - rotation
 * @property {string} sampleAspectRatio - sample aspect ratio
 * @property {string} sampleRate - sample rate (audio only)
 * @property {string} sessionId - session id (video maker , mmgr etc)
 * @property {string} source - Source of image - upload from computer, mobile, import from FB, edited image, video maker etc
 * @property {string} sourceUrl - url for VM videos
 * @property {string} stage - upload stage (upload, transcode etc.)
 * @property {string} tags - system tags
 * @property {string} target - upload / facebook / drive / dropbox / wix_sites / url / upload_drag_and_drop / vimeo / etc
 * @property {number} videoDuration - video duration in ms
 * @property {number} width - width
 * @return {LogObject<mediaBeUploadFinishParams>} LogObject<mediaBeUploadFinishParams>
 */
export function mediaBeUploadFinish(params) {
    return { evid: 801, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaEditorPanelOpened' event (evid: 662)
 *
 * Event description: Panel_Opened
 *
 * @param {mediaEditorPanelOpenedParams} params - The parameters for this event
 * @property {string} dm_version - .
 * @property {string} editorVersion - .
 * @property {string} editor_version - .
 * @property {string} editor_working_mode - editor_working_mode
 * @property {GUID} esi - editor session id
 * @property {string} focused_page_id - focused_page_id
 * @property {string} js_heap_size_limit - []
 * @property {string} jsonData - json with sections and file_ids list for each (for Media Editor panel open): { "sectionName1": ["file1", "file2", "file3"], "sectionName2": ["file5", "file6", "file3"] }
 * @property {number} loadingTime - ms
 * @property {number} loadingTimeRecommended - ms (time to recommended section displayed. Starting time =  from other sections displayed in panel)
 * @property {GUID} msid - site
 * @property {string} multilingual - []
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {boolean} recentlySectionExists - t / f
 * @property {string} recommendedSectionExists - as_card / as_section_with_images / no
 * @property {string} sessionId
 * @property {string} source
 * @property {string} total_js_heap_size - []
 * @property {number} ts - ts
 * @property {string} used_js_heap_size - []
 * @property {string} viewerName - viewer_name
 * @property {string} viewmode - viewmode
 * @return {LogObject<mediaEditorPanelOpenedParams>} LogObject<mediaEditorPanelOpenedParams>
 */
export function mediaEditorPanelOpened(params) {
    return { evid: 662, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerTagsActions' event (evid: 614)
 *
 * Event description: Actions related to adding / deleting tags
 *
 * @param {mediaManagerTagsActionsParams} params - The parameters for this event
 * @property {string} clickOrigin - more_info / add_media
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file id
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @property {string} tag - sport / yoga etc
 * @property {string} target - added / deleted
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<mediaManagerTagsActionsParams>} LogObject<mediaManagerTagsActionsParams>
 */
export function mediaManagerTagsActions(params) {
    return { evid: 614, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerWhenAUserClicksOnEditVideo' event (evid: 5)
 *
 * Event description: When a user clicks on edit when viewing a video in the camera component
 *
 * @param {mediaManagerWhenAUserClicksOnEditVideoParams} params - The parameters for this event
 * @property {string} fileId - Private Media file ID
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @return {LogObject<mediaManagerWhenAUserClicksOnEditVideoParams>} LogObject<mediaManagerWhenAUserClicksOnEditVideoParams>
 */
export function mediaManagerWhenAUserClicksOnEditVideo(params) {
    return { evid: 5, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerPanelFileInfoActionsClick' event (evid: 674)
 *
 * Event description: User click on some actions buuton in the info panel
 *
 * @param {mediaManagerPanelFileInfoActionsClickParams} params - The parameters for this event
 * @property {string} actionName - restore / delete_forever / create_new_folder / show_more / share_video
 * @property {string} clickOrigin - more_info
 * @property {string} fileFormat - file_format
 * @property {string} fileId - file id (users file, free or shutter, should have valid id)
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {GUID} msid - msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session_id
 * @property {string} source - source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<mediaManagerPanelFileInfoActionsClickParams>} LogObject<mediaManagerPanelFileInfoActionsClickParams>
 */
export function mediaManagerPanelFileInfoActionsClick(params) {
    return { evid: 674, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerFavoritesActions' event (evid: 617)
 *
 * Event description: Event for every favorite action (add / remove), shoot on every file
 *
 * @param {mediaManagerFavoritesActionsParams} params - The parameters for this event
 * @property {boolean} batch - true / false
 * @property {number} batchSize - items amount
 * @property {string} clickOrigin - clickOrigin
 * @property {string} correlationId - one batch id
 * @property {string} fileFormat - extension
 * @property {string} fileId - file id
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - layout
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - video / image / etc
 * @property {GUID} msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - tabName
 * @property {string} target - add / remove
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<mediaManagerFavoritesActionsParams>} LogObject<mediaManagerFavoritesActionsParams>
 */
export function mediaManagerFavoritesActions(params) {
    return { evid: 617, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerErrorScreenPageview' event (evid: 666)
 *
 * Event description: Error screen "Something went wrong" appears
 *
 * @param {mediaManagerErrorScreenPageviewParams} params - The parameters for this event
 * @property {string} context - context
 * @property {string} errorReason - error desc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock / trash
 * @return {LogObject<mediaManagerErrorScreenPageviewParams>} LogObject<mediaManagerErrorScreenPageviewParams>
 */
export function mediaManagerErrorScreenPageview(params) {
    return { evid: 666, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerLayoutChanged' event (evid: 607)
 *
 * Event description: Layout changed
 *
 * @param {mediaManagerLayoutChangedParams} params - The parameters for this event
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} previousSelection - gallery / gallery_more_info / list / list_more_info
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @return {LogObject<mediaManagerLayoutChangedParams>} LogObject<mediaManagerLayoutChangedParams>
 */
export function mediaManagerLayoutChanged(params) {
    return { evid: 607, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'searchAndFiltersNoResultsTryToClick' event (evid: 652)
 *
 * Event description: Users clicks on Try to clear filters / search all locations on empty search results page
 *
 * @param {searchAndFiltersNoResultsTryToClickParams} params - The parameters for this event
 * @property {string} clickOrigin - clear search / reset filters
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @return {LogObject<searchAndFiltersNoResultsTryToClickParams>} LogObject<searchAndFiltersNoResultsTryToClickParams>
 */
export function searchAndFiltersNoResultsTryToClick(params) {
    return { evid: 652, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'addMediaImportFilesPopUpActions' event (evid: 626)
 *
 * Event description: Import files pop up opened / closed
 *
 * @param {addMediaImportFilesPopUpActionsParams} params - The parameters for this event
 * @property {string} layout - layout
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / vimeo / etc.
 * @property {string} target - opened / closed
 * @return {LogObject<addMediaImportFilesPopUpActionsParams>} LogObject<addMediaImportFilesPopUpActionsParams>
 */
export function addMediaImportFilesPopUpActions(params) {
    return { evid: 626, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerExceedingQuotaPopUpClick' event (evid: 656)
 *
 * Event description: A user clicked on Your storage is full pop up (not now, close)
 * (Upgrade click has a separate BI event!)
 *
 * @param {mediaManagerExceedingQuotaPopUpClickParams} params - The parameters for this event
 * @property {string} layout - layout
 * @property {GUID} msid - msid
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId - sessionId
 * @property {string} source - source
 * @property {string} tabName - the tab the manager was opened
 * @return {LogObject<mediaManagerExceedingQuotaPopUpClickParams>} LogObject<mediaManagerExceedingQuotaPopUpClickParams>
 */
export function mediaManagerExceedingQuotaPopUpClick(params) {
    return { evid: 656, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'addMediaSideBarActions' event (evid: 621)
 *
 * Event description: Add media sidebar opened or closed, or user clicks on its buttons during or after import
 *
 * @param {addMediaSideBarActionsParams} params - The parameters for this event
 * @property {boolean} batch - several files in one import
 * @property {string} batchId - batch id
 * @property {number} batchSize - amount of files
 * @property {string} correlationId - id to find one upload process
 * @property {boolean} is_resumable - is download resume available for this file
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} parent_correlation_id - in case of uploading multiple files, send an ID that will indicate the overall upload process of all files
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites etc.
 * @property {string} target - sidebar_opened / sidebar_closed / cancel_all / retry / clear_list / go_to_file / edit_tags / resume / close / clear_error / retry
 * @return {LogObject<addMediaSideBarActionsParams>} LogObject<addMediaSideBarActionsParams>
 */
export function addMediaSideBarActions(params) {
    return { evid: 621, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'addMediaUploadingCompleted' event (evid: 633)
 *
 * Event description: Media upload uploading completed
 *
 * @param {addMediaUploadingCompletedParams} params - The parameters for this event
 * @property {number} auto_resumed - count how many times (in current correlation_id) upload was resumed automatically
 * @property {boolean} batch - several files in one import
 * @property {string} batchId - batch id
 * @property {number} batchSize - amount of files
 * @property {string} clickOrigin - full_size
 * @property {string} correlationId - id to find one upload process
 * @property {string} errorKey - errorKey
 * @property {string} errorReason - errors (technical_issue / connectivity_issue resume_error)
 * @property {string} fileFormat - file extension
 * @property {number} fileSize - file size in KB
 * @property {string} layout - layout
 * @property {number} loadingTime - loading time
 * @property {number} manual_resumed - count how many times upload was resumed manually
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} parent_correlation_id - in case of uploading multiple files, send an ID that will indicate the overall upload process of all files
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {boolean} success - true / false
 * @property {string} tabName - tab
 * @property {string} target - upload / facebook / drive / dropbox / wix_sites / url / upload_drag_and_drop / vimeo / etc
 * @return {LogObject<addMediaUploadingCompletedParams>} LogObject<addMediaUploadingCompletedParams>
 */
export function addMediaUploadingCompleted(params) {
    return { evid: 633, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerPanelClose' event (evid: 643)
 *
 * Event description: User click on close panel (right side)
 *
 * @param {mediaManagerPanelCloseParams} params - The parameters for this event
 * @property {string} clickOrigin - close / action_menu
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaType - mage / video / audio / doc / mixed / folder
 * @property {GUID} msid - msid
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId - sessionId
 * @property {string} source - source
 * @property {string} tabName - site_files / my_favorites etc.
 * @return {LogObject<mediaManagerPanelCloseParams>} LogObject<mediaManagerPanelCloseParams>
 */
export function mediaManagerPanelClose(params) {
    return { evid: 643, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerPreviewActions' event (evid: 610)
 *
 * Event description: Actions related to file preview
 *
 * @param {mediaManagerPreviewActionsParams} params - The parameters for this event
 * @property {string} clickOrigin - more_info / left_arrow / right_arrow / keyboard
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file id
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin
 * @property {string} pageName - Media Manager / Storage Manager
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @property {string} target - opened / closed
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<mediaManagerPreviewActionsParams>} LogObject<mediaManagerPreviewActionsParams>
 */
export function mediaManagerPreviewActions(params) {
    return { evid: 610, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerAddToBoardMenuClick' event (evid: 682)
 *
 * Event description: User clicks on Add to Board pop up
 *
 * @param {mediaManagerAddToBoardMenuClickParams} params - The parameters for this event
 * @property {string} clickOrigin - click_origin
 * @property {string} context - context
 * @property {string} fileFormat - .
 * @property {string} fileId - file id or json
 * @property {string} fileOrigin - .
 * @property {string} fileType - .
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - .
 * @property {GUID} msid - site
 * @property {string} name - .
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - session id
 * @property {string} source - who opened
 * @property {string} tabName - tab_name
 * @property {string} target - add /  new
 * @property {GUID} teammate_id - teammate_id
 * @return {LogObject<mediaManagerAddToBoardMenuClickParams>} LogObject<mediaManagerAddToBoardMenuClickParams>
 */
export function mediaManagerAddToBoardMenuClick(params) {
    return { evid: 682, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'storageManagerError' event (evid: 817)
 *
 * Event description: Error happened while using Storage Manager (error moving to trash / error permanently delete).
 *
 * @param {storageManagerErrorParams} params - The parameters for this event
 * @property {boolean} batch - file size
 * @property {GUID} batchId - batch id
 * @property {string} errorReason - move_to_trash_error / permanently_delete_error
 * @property {string} errorType - type of error
 * @property {string} fileId - file id
 * @property {string} fileType - png / mp4 / ...
 * @property {GUID} msid - site
 * @property {string} origin - editor / studio / business manager
 * @property {string} pageName - Media Manager / Storage Manager
 * @property {string} publicMediaRoot - media public root
 * @property {string} sessionId - media manager session id
 * @property {string} source - source
 * @property {string} tabName - storage_manager_site_files / storage_manager_trash
 * @property {GUID} uuid - user id
 * @return {LogObject<storageManagerErrorParams>} LogObject<storageManagerErrorParams>
 */
export function storageManagerError(params) {
    return { evid: 817, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaPurchasePageOpened' event (evid: 678)
 *
 * Event description: purchase page opened successfully
 *
 * @param {mediaPurchasePageOpenedParams} params - The parameters for this event
 * @property {string} fileId - shutterstock file id or WIX file_id
 * @property {boolean} isNew - t for real purchase, f for purchase of already purchased item (so item just copied)
 * @property {string} mediaProducer - Shutterstock or Wix Stock
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid - msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - session_id
 * @property {string} source - source
 * @property {string} tab - MM - ST tab / MM - MH tab / MM - WIX tab / EMP - ST section / EMP - recommended / EMP - WIX section
 * @return {LogObject<mediaPurchasePageOpenedParams>} LogObject<mediaPurchasePageOpenedParams>
 */
export function mediaPurchasePageOpened(params) {
    return { evid: 678, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerFileChosenTry' event (evid: 664)
 *
 * Event description: Click on file choose button disabled
 * when user has wrong file type
 *
 * @param {mediaManagerFileChosenTryParams} params - The parameters for this event
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file id (users file, free or shutter, should have valid id)
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid - msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session_id
 * @property {string} source - source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<mediaManagerFileChosenTryParams>} LogObject<mediaManagerFileChosenTryParams>
 */
export function mediaManagerFileChosenTry(params) {
    return { evid: 664, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'homeRecentFilesButtonClick' event (evid: 676)
 *
 * Event description: User clicks on a button in Recent files section (media home tab)
 *
 * @param {homeRecentFilesButtonClickParams} params - The parameters for this event
 * @property {string} button_name - see_all / nav_right / nav_left
 * @property {string} layout - layout
 * @property {GUID} msid - site
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session_id
 * @property {string} source - who open MM (stores, bookings etc.)
 * @property {string} tabName - tabName
 * @return {LogObject<homeRecentFilesButtonClickParams>} LogObject<homeRecentFilesButtonClickParams>
 */
export function homeRecentFilesButtonClick(params) {
    return { evid: 676, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'addMediaWaitingCompleted' event (evid: 631)
 *
 * Event description: Media upload waiting completed
 *
 * @param {addMediaWaitingCompletedParams} params - The parameters for this event
 * @property {boolean} batch - several files in one import
 * @property {string} batchId - batch id
 * @property {number} batchSize - amount of files
 * @property {string} clickOrigin - full_size
 * @property {string} correlationId - id to find one upload process
 * @property {string} errorReason - errors
 * @property {string} fileFormat - file extension
 * @property {string} layout - layout
 * @property {number} loadingTime - loading time
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} parent_correlation_id - in case of uploading multiple files, send an ID that will indicate the overall upload process of all files
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {boolean} success - true / false
 * @property {string} tabName - tab name
 * @property {string} target - upload / facebook / drive / dropbox / wix_sites / url / upload_drag_and_drop / vimeo / etc
 * @return {LogObject<addMediaWaitingCompletedParams>} LogObject<addMediaWaitingCompletedParams>
 */
export function addMediaWaitingCompleted(params) {
    return { evid: 631, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'addMediaButtonClick' event (evid: 620)
 *
 * Event description: Click on "+ Add Media" button
 *
 * @param {addMediaButtonClickParams} params - The parameters for this event
 * @property {string} clickOrigin - side_bar / start_adding
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites etc.
 * @return {LogObject<addMediaButtonClickParams>} LogObject<addMediaButtonClickParams>
 */
export function addMediaButtonClick(params) {
    return { evid: 620, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaEditorPanelSearchFinish' event (evid: 659)
 *
 * Event description: Search in Media Editor Panel finish
 *
 * @param {mediaEditorPanelSearchFinishParams} params - The parameters for this event
 * @property {string} dm_version - .
 * @property {string} editor_version - .
 * @property {string} editor_working_mode - editor_working_mode
 * @property {GUID} esi - editor session id
 * @property {string} focused_page_id - focused_page_id
 * @property {string} js_heap_size_limit - []
 * @property {string} jsonData - json with search shown results { "recently": ["file1", "file2", "file3"], "section2": ["file5", "file6", "file3"] }
 * @property {number} loadingTime - ms
 * @property {GUID} msid - site
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {boolean} success - at least 1 result shown
 * @property {string} target - search term
 * @property {string} total_js_heap_size - []
 * @property {number} ts - ts
 * @property {string} used_js_heap_size - []
 * @property {string} viewerName - viewer_name
 * @property {string} viewmode - viewmode
 * @return {LogObject<mediaEditorPanelSearchFinishParams>} LogObject<mediaEditorPanelSearchFinishParams>
 */
export function mediaEditorPanelSearchFinish(params) {
    return { evid: 659, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerLoaded' event (evid: 600)
 *
 * Event description: Shoot on mm on every open (loaded from scratch or hidden) when files in MM fully loaded and user can see them
 *
 * @param {mediaManagerLoadedParams} params - The parameters for this event
 * @property {string} context - image / video / doc etc
 * @property {string} layout - layout: list, icons
 * @property {number} loadingTime - loading_time
 * @property {GUID} msid - msid id
 * @property {string} origin - Editor / Adi / BM
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - session id
 * @property {string} source - who is opening MM
 * @property {string} tabName - the tab the manager will be opened or empty for warmup
 * @return {LogObject<mediaManagerLoadedParams>} LogObject<mediaManagerLoadedParams>
 */
export function mediaManagerLoaded(params) {
    return { evid: 600, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaBeAiProviderCall' event (evid: 814)
 *
 * Event description: Call to provider is made to generate with AI
 *
 * @param {mediaBeAiProviderCallParams} params - The parameters for this event
 * @property {string} context - image / video / doc etc
 * @property {string} correlationId - correlation_id to combine with 110
 * @property {number} cost - cost of the call
 * @property {string} feature - AI Image Creator, Object Eraser, AI Editing, Expand
 * @property {number} imagesAmount - number of images created in the call
 * @property {number} loadingTime - loading_time
 * @property {string} mimeType - video/mp4
 * @property {GUID} msid - msid
 * @property {string} namespace - the company namespace
 * @property {string} origin - Application initiating the upload - MMgr, PStudio, Mobile etc
 * @property {string} provider - Outsource provider
 * @property {string} publicMediaRoot - .
 * @property {string} sessionId - session_id
 * @property {string} source - the entry point
 * @property {boolean} success - true / false
 * @property {string} tabName - tab name
 * @return {LogObject<mediaBeAiProviderCallParams>} LogObject<mediaBeAiProviderCallParams>
 */
export function mediaBeAiProviderCall(params) {
    return { evid: 814, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerAUserClickOnVideoInPreviewScreen' event (evid: 4)
 *
 * Event description: when the user enter for his first time to upload video the statement 'set the video quality for upload' will show.
 *
 * @param {mediaManagerAUserClickOnVideoInPreviewScreenParams} params - The parameters for this event
 * @property {string} fileId - Private Media file ID
 * @property {number} mediaSize - size of media
 * @property {string} mediaType - video, img
 * @property {GUID} msid - the business id
 * @property {string} origin - the origin of screen (mobile and etc)
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @return {LogObject<mediaManagerAUserClickOnVideoInPreviewScreenParams>} LogObject<mediaManagerAUserClickOnVideoInPreviewScreenParams>
 */
export function mediaManagerAUserClickOnVideoInPreviewScreen(params) {
    return { evid: 4, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerMediaPurchaseCompleted' event (evid: 680)
 *
 * Event description: User successfully purchased media from Shutterstock or Wix Stock
 *
 * @param {mediaManagerMediaPurchaseCompletedParams} params - The parameters for this event
 * @property {string} category - for free from wix or shutter, json
 * @property {string} editor_version - .
 * @property {string} editor_working_mode - .
 * @property {GUID} esi - .
 * @property {string} fileFormat - file extension
 * @property {string} fileId - shutterstock file id
 * @property {string} focused_page_id - .
 * @property {boolean} isNew - t for real purchase, f for purchase of already purchased item (so item just copied)
 * @property {string} jsHeapSizeLimit - .
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaProducer - Shutterstock or Wix Stock
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid - msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} section - section in Editor panel (shutterstock_tab / recommended_tab)
 * @property {string} sessionId - session_id
 * @property {string} source - source
 * @property {string} tabName - tab name in MM
 * @property {string} totalJsHeapSize - .
 * @property {number} ts - .
 * @property {string} usedJsHeapSize - .
 * @return {LogObject<mediaManagerMediaPurchaseCompletedParams>} LogObject<mediaManagerMediaPurchaseCompletedParams>
 */
export function mediaManagerMediaPurchaseCompleted(params) {
    return { evid: 680, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'adobeErrorToast' event (evid: 816)
 *
 * Event description: Error happened while using Adobe (error opening / error saving).
 *
 * @param {adobeErrorToastParams} params - The parameters for this event
 * @property {string} errorReason - opening_error, saving_error
 * @property {GUID} msid - site
 * @property {string} origin - editor / studio / business manager
 * @property {string} publicMediaRoot - media public root
 * @property {string} sessionId - media manager session id
 * @property {string} source - source
 * @return {LogObject<adobeErrorToastParams>} LogObject<adobeErrorToastParams>
 */
export function adobeErrorToast(params) {
    return { evid: 816, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerDeleteBoardPopUpClick' event (evid: 688)
 *
 * Event description: User clicks on Delete board Pop up
 *
 * @param {mediaManagerDeleteBoardPopUpClickParams} params - The parameters for this event
 * @property {string} boardId - board_id or favorites
 * @property {string} context - context
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid - site
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - session id
 * @property {string} source - who opened
 * @property {string} tabName - tab_name
 * @property {string} target - delete / cancel / close
 * @return {LogObject<mediaManagerDeleteBoardPopUpClickParams>} LogObject<mediaManagerDeleteBoardPopUpClickParams>
 */
export function mediaManagerDeleteBoardPopUpClick(params) {
    return { evid: 688, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerLayoutClick' event (evid: 606)
 *
 * Event description: Click on layout icon to open dropdown
 *
 * @param {mediaManagerLayoutClickParams} params - The parameters for this event
 * @property {string} clickOrigin - top_right / actions  / top_center
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @return {LogObject<mediaManagerLayoutClickParams>} LogObject<mediaManagerLayoutClickParams>
 */
export function mediaManagerLayoutClick(params) {
    return { evid: 606, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'newSearchClick' event (evid: 691)
 *
 * Event description: newSearch.click
 *
 * @param {newSearchClickParams} params - The parameters for this event
 * @property {string} button_name - new_search / search_again
 * @property {string} layout - .
 * @property {GUID} msid - site
 * @property {string} origin - origin
 * @property {string} publicMediaRoot - .
 * @property {string} sessionId - session_id
 * @property {string} source - who open MM (stores, bookings etc.)
 * @property {string} tabName - tabName
 * @return {LogObject<newSearchClickParams>} LogObject<newSearchClickParams>
 */
export function newSearchClick(params) {
    return { evid: 691, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaBeCsamDetection' event (evid: 803)
 *
 * Event description: Event sent on all CSAM (Child Sexual Abuse Materials) detection requests
 *
 * @param {mediaBeCsamDetectionParams} params - The parameters for this event
 * @property {string} adultLikelihood - VERY_LIKELY | LIKELY | POSSIBLE
 * @property {string} enLabels - ["Hairstyle","Blazer","Formal wear","Gentleman"]
 * @property {string} fileFormat - File extension
 * @property {string} fileId - Private Media file ID
 * @property {string} fileUrl - Relative Media file URL
 * @property {string} mediaType - Media type (picture/video)
 * @property {string} mimeType - Mime Type (image/png)
 * @property {GUID} msid - Metasite ID
 * @property {string} netsparkCode - Netspark inspection code
 * @property {string} netsparkConfidence - confidence (1-99)
 * @property {string} netsparkDescription - Netspark inspection description
 * @property {number} netsparkProcessingDuration - Request processing duration at Netspark (in seconds)
 * @property {boolean} netsparkFlagged - True/False
 * @property {string} netsparkOpId - Operation ID
 * @property {string} origin
 * @property {string} originalFileName - Original file title
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tags - System tags (["_fileOrigin_uploaded"])
 * @property {number} videoDuration - Duration of the video file (in seconds)
 * @return {LogObject<mediaBeCsamDetectionParams>} LogObject<mediaBeCsamDetectionParams>
 */
export function mediaBeCsamDetection(params) {
    return { evid: 803, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'unsplashLinkClick' event (evid: 669)
 *
 * Event description: User clicks on terms, learn more or designer name on Unsplash tab
 *
 * @param {unsplashLinkClickParams} params - The parameters for this event
 * @property {string} clickOrigin - unsplash_tab / preview
 * @property {string} context - context
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid - site
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session id
 * @property {string} source - who opened
 * @property {string} tabName - unsplash
 * @property {string} target - terms, learn_more etc
 * @return {LogObject<unsplashLinkClickParams>} LogObject<unsplashLinkClickParams>
 */
export function unsplashLinkClick(params) {
    return { evid: 669, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerUpgradeButtonClick' event (evid: 811)
 *
 * Event description: User clicks on the upgrade button
 *
 * @param {mediaManagerUpgradeButtonClickParams} params - The parameters for this event
 * @property {string} context - image / video / doc etc
 * @property {string} layout - layout
 * @property {string} mmgrVersion - MM version on load
 * @property {GUID} msid - .
 * @property {string} origin - .
 * @property {string} pageName - Media Manager / Storage Manage
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - .
 * @property {string} source - .
 * @property {string} storage_status - not_exceeding,  about_to_exceed, exceed
 * @property {string} tabName - the tab the manager was opened
 * @property {string} upgrade_origin - tooltip, toast, storage_indicator, upload_popup_toast, storage_is_full_popup
 * @return {LogObject<mediaManagerUpgradeButtonClickParams>} LogObject<mediaManagerUpgradeButtonClickParams>
 */
export function mediaManagerUpgradeButtonClick(params) {
    return { evid: 811, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'searchAndFiltersFinished' event (evid: 651)
 *
 * Event description: Shoot on search finish or after filter applied
 *
 * @param {searchAndFiltersFinishedParams} params - The parameters for this event
 * @property {string} clickOrigin - search / filter_categories / filter_color / filter_media_type / filter_orientation / search_from_related / tag
 * @property {string} context - context
 * @property {string} correlationId - correlation id
 * @property {string} errorType - canceled_by_user / no_results / technical
 * @property {string} file_list - list of the files id by their order
 * @property {string} filterCategory - category that was filtered when user use search/filter
 * @property {string} filterColor - the color user filtered
 * @property {string} filterOrientation - orientation that was filtered when user use search/filter
 * @property {string} filterPricing - price
 * @property {string} filterType - type that was filtered when user use search/filter
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {number} loadingTime - time
 * @property {GUID} msid
 * @property {number} numOfResults - num of search results
 * @property {string} origin
 * @property {string} pageName - Media Manager / Storage Manager
 * @property {string} publicMediaRoot
 * @property {GUID} search_id - Search ID
 * @property {string} section_name_list - In general search a few sections will appear and in stocks search one section: Site Files / Media From Wix / Unsplash / Shutterstock
 * @property {number} sectionsAmount - number of shown sections
 * @property {string} sectionsArray - for search: array with all shown sections
 * @property {string} sessionId
 * @property {string} source
 * @property {boolean} success - true (at least 1 item shown) / false
 * @property {string} tabName - site_files / my_favorites / free / shutterstock / storage_manager_site_files / storage_manager_trash
 * @property {string} target - what does user search for (term, phrase, word) or settings from filter (ex. media_type = video, then video)
 * @return {LogObject<searchAndFiltersFinishedParams>} LogObject<searchAndFiltersFinishedParams>
 */
export function searchAndFiltersFinished(params) {
    return { evid: 651, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerPanelFileInfoCopyUrlClick' event (evid: 667)
 *
 * Event description: User clicks on copy Url from panel (More Info section)
 *
 * @param {mediaManagerPanelFileInfoCopyUrlClickParams} params - The parameters for this event
 * @property {string} actionName - copy_url
 * @property {string} clickOrigin - panel
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file or folder id
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - image / video / audio / doc / mixed / null
 * @property {GUID} msid - msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session_id
 * @property {string} source - source
 * @property {string} tabName - site_files / my_favorites etc.
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<mediaManagerPanelFileInfoCopyUrlClickParams>} LogObject<mediaManagerPanelFileInfoCopyUrlClickParams>
 */
export function mediaManagerPanelFileInfoCopyUrlClick(params) {
    return { evid: 667, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerTrashActions' event (evid: 615)
 *
 * Event description: Event for every trash action (added_to_trash / restored / delete_forever), shoot on every file
 *
 * @param {mediaManagerTrashActionsParams} params - The parameters for this event
 * @property {boolean} batch - true / false
 * @property {number} batchSize - items amount
 * @property {string} clickOrigin - more_info / dots / right_click / more_actions_top_right
 * @property {string} correlationId - one batch id
 * @property {string} fileFormat - extension
 * @property {string} fileId - file id
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - layout
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - video / image / etc
 * @property {GUID} msid - msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin - origin
 * @property {string} pageName - Media Manager / Storage Manager
 * @property {string} publicMediaRoot - public media root
 * @property {string} sessionId - session id
 * @property {string} source - source
 * @property {string} tabName - tabName
 * @property {string} target - added_to_trash / restored / delete_forever
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<mediaManagerTrashActionsParams>} LogObject<mediaManagerTrashActionsParams>
 */
export function mediaManagerTrashActions(params) {
    return { evid: 615, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerSetVideoQualityOptionClicked' event (evid: 6)
 *
 * Event description: When a user clicks on video quality screen one option
 *
 * @param {mediaManagerSetVideoQualityOptionClickedParams} params - The parameters for this event
 * @property {string} fileId - Private Media file ID
 * @property {GUID} msid - business id
 * @property {string} option_value - High/Medium/Low/Original
 * @property {string} origin - Application initiating the upload - MMgr, PStudio, Mobile etc
 * @property {string} publicMediaRoot - [{"b":241,"g":234,"r":198}]
 * @property {string} sessionId - session id (video maker , mmgr etc)
 * @property {string} source - Source of image - upload from computer, mobile, import from FB, edited image, video maker etc
 * @return {LogObject<mediaManagerSetVideoQualityOptionClickedParams>} LogObject<mediaManagerSetVideoQualityOptionClickedParams>
 */
export function mediaManagerSetVideoQualityOptionClicked(params) {
    return { evid: 6, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaPurchasePageLoaded' event (evid: 677)
 *
 * Event description: purchase page loaded
 *
 * @param {mediaPurchasePageLoadedParams} params - The parameters for this event
 * @property {string} fileId - shutterstock file id or WIX file_id
 * @property {boolean} isSuccess - true/false
 * @property {string} mediaProducer - Shutterstock or Wix Stock
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid - msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot
 * @property {string} sessionId - session_id
 * @property {string} source
 * @property {string} tab - MM - ST tab / MM - MH tab / MM - WIX tab / EMP - ST section / EMP - recommended / EMP - WIX section
 * @return {LogObject<mediaPurchasePageLoadedParams>} LogObject<mediaPurchasePageLoadedParams>
 */
export function mediaPurchasePageLoaded(params) {
    return { evid: 677, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerLearnMoreClick' event (evid: 613)
 *
 * Event description: User clicks on Learn more buttons or links which leads to learn more info
 *
 * @param {mediaManagerLearnMoreClickParams} params - The parameters for this event
 * @property {string} clickOrigin - shared_files / site_contributers / mobile_uploads / wix_app / trash / facebook_connect / add_media_bar / tooltip / toast / storage_indicator / upload_popup_toast / storage_is_full_popup
 * @property {string} errorType - which operation has failed
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} pageName - Media Manager / Storage Manager
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} storage_status - not_exceeding,  about_to_exceed, exceed
 * @property {string} tabName - site_files / my_favorites / free / shutterstock / trash
 * @property {string} type - storage or other
 * @return {LogObject<mediaManagerLearnMoreClickParams>} LogObject<mediaManagerLearnMoreClickParams>
 */
export function mediaManagerLearnMoreClick(params) {
    return { evid: 613, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerSideBarClick' event (evid: 603)
 *
 * Event description: Click on tabs on the side bar
 *
 * @param {mediaManagerSideBarClickParams} params - The parameters for this event
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites etc (current tab before click)
 * @property {string} target - site_files / visitor_uploads / favorites / trash / recommended / free_from_wix / shutterstock / uploading_view_details / home
 * @return {LogObject<mediaManagerSideBarClickParams>} LogObject<mediaManagerSideBarClickParams>
 */
export function mediaManagerSideBarClick(params) {
    return { evid: 603, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'homeRecommendedButtonClick' event (evid: 675)
 *
 * Event description: User clicks on a button in Recommended section (media home tab)
 *
 * @param {homeRecommendedButtonClickParams} params - The parameters for this event
 * @property {string} button_name - apply / see_all / nav_right / nav_left / settings
 * @property {string} layout - layout
 * @property {GUID} msid - site
 * @property {string} origin - origin
 * @property {string} publicMediaRoot
 * @property {string} selection - string with all user selection (art, nature etc.)
 * @property {string} sessionId - session_id
 * @property {string} source - who open MM (stores, bookings etc.)
 * @property {string} tabName - tabName
 * @return {LogObject<homeRecommendedButtonClickParams>} LogObject<homeRecommendedButtonClickParams>
 */
export function homeRecommendedButtonClick(params) {
    return { evid: 675, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerTeammatesViewClick' event (evid: 694)
 *
 * Event description: User clicks to view team list on a sidebar or when creating a new board
 *
 * @param {mediaManagerTeammatesViewClickParams} params - The parameters for this event
 * @property {string} boardId - board_id
 * @property {string} clickOrigin - side_panel / create_new_board
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid - site
 * @property {string} origin - adi / editor
 * @property {string} publicMediaRoot - public_media_root
 * @property {string} sessionId - session id
 * @property {string} source - who opened
 * @return {LogObject<mediaManagerTeammatesViewClickParams>} LogObject<mediaManagerTeammatesViewClickParams>
 */
export function mediaManagerTeammatesViewClick(params) {
    return { evid: 694, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'searchAndFiltersShowAllClick' event (evid: 653)
 *
 * Event description: Users clicks on 'Show all results' when searching 'site files' (only search)
 *
 * @param {searchAndFiltersShowAllClickParams} params - The parameters for this event
 * @property {string} clickOrigin - search
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {number} sectionsAmount - number of shown sections
 * @property {string} sectionsArray - for search: array with all shown sections
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @property {string} target - everywhere / site_files / free / shutterstock / section name / business etc
 * @return {LogObject<searchAndFiltersShowAllClickParams>} LogObject<searchAndFiltersShowAllClickParams>
 */
export function searchAndFiltersShowAllClick(params) {
    return { evid: 653, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerFileClick' event (evid: 609)
 *
 * Event description: User clicks on file or folder to choose it / enter / move etc
 * Shoot on every file (for lasso)
 *
 * @param {mediaManagerFileClickParams} params - The parameters for this event
 * @property {string} clickOrigin - click / lasso / drag_and_drop / preview_enter_folder / breadcrumbs / keyboard
 * @property {number} clicked_file_index - Index of the image clicked appeared in layout
 * @property {string} fileFormat - file extension
 * @property {string} fileId - file id
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - gallery / gallery_more_info / list / list_more_info
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {GUID} search_id - Search ID
 * @property {number} section_index - The number of section the file was selected from
 * @property {string} section_name - The section selected from out of section appeared in search: Site Files / Media From Wix / Unsplash / Shutterstock
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - site_files / my_favorites / free / shutterstock / upload_widget_facebook / upload_widget_instagram
 * @property {string} targetFolderMsid - msid of site of selected folder
 * @property {string} videoSession - video session id from VM
 * @return {LogObject<mediaManagerFileClickParams>} LogObject<mediaManagerFileClickParams>
 */
export function mediaManagerFileClick(params) {
    return { evid: 609, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaEditorPanelShutterstockPurchaseButtonClick' event (evid: 660)
 *
 * Event description: User clicks on Purchase on Shutterstock item in MediaEditorPanel
 *
 * @param {mediaEditorPanelShutterstockPurchaseButtonClickParams} params - The parameters for this event
 * @property {string} category - image / video
 * @property {string} editor_version - .
 * @property {string} editor_working_mode - editor_working_mode
 * @property {GUID} esi - editor session id
 * @property {string} fileId - file
 * @property {string} focused_page_id - focused_page_id
 * @property {string} js_heap_size_limit - []
 * @property {string} mediaProducer - Shutterstock or Wix Stock
 * @property {GUID} msid - site
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} section - section in Editor panel (shutterstock_tab / recommended_tab)
 * @property {string} sessionId
 * @property {string} source
 * @property {string} total_js_heap_size - []
 * @property {number} ts - ts
 * @property {string} used_js_heap_size - []
 * @property {string} viewerName - viewer_name
 * @property {string} viewmode - viewmode
 * @return {LogObject<mediaEditorPanelShutterstockPurchaseButtonClickParams>} LogObject<mediaEditorPanelShutterstockPurchaseButtonClickParams>
 */
export function mediaEditorPanelShutterstockPurchaseButtonClick(params) {
    return { evid: 660, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'storageManagerOpenedSrc26Evid820' event (evid: 820)
 *
 * Event description: Shoot every time when the storage widget is loaded
 *
 * @param {storageManagerOpenedSrc26Evid820Params} params - The parameters for this event
 * @property {number} loadingTime - loading time
 * @property {GUID} msid - msid
 * @property {string} origin - media manager, BM - video maker, BM - wix video, BM - wix music, premium
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source - upload, copy, edit and duplicate, edit video, shutterstock purchase, upgrade, delete
 * @property {string} tabName - storage_manager_site_files / storage_manager_trash
 * @return {LogObject<storageManagerOpenedSrc26Evid820Params>} LogObject<storageManagerOpenedSrc26Evid820Params>
 */
export function storageManagerOpenedSrc26Evid820(params) {
    return { evid: 820, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerDownloadImage' event (evid: 818)
 *
 * Event description: User downloaded file from Media Manager or Storage Manager
 *
 * @param {mediaManagerDownloadImageParams} params - The parameters for this event
 * @property {boolean} batch - true / false
 * @property {number} batchSize - items amount
 * @property {string} clickOrigin - button / more_info / dots / right_click / more_actions_top_right
 * @property {string} correlationId - one batch id
 * @property {string} fileFormat - extension
 * @property {GUID} fileId - file id
 * @property {string} fileOrigin - Which file user add: vm/Facebook/Instagram/Uploded etc.
 * @property {string} fileType - all, video, transparent_video, pattern, texture, illustration, basic_shape, vector_art etc
 * @property {string} layout - layout
 * @property {string} mediaOrigin - private / shutterstock / ffw / etc
 * @property {string} mediaType - video / image / etc
 * @property {GUID} msid - site id
 * @property {string} name - image name (for free from wix or shutter)
 * @property {string} origin - editor / BO / etc
 * @property {string} pageName - Media Manager / Storage Manager
 * @property {string} publicMediaRoot - public media root
 * @property {string} sessionId - guid
 * @property {string} source - entry point
 * @property {boolean} success - true / false
 * @property {string} tabName - tabName
 * @return {LogObject<mediaManagerDownloadImageParams>} LogObject<mediaManagerDownloadImageParams>
 */
export function mediaManagerDownloadImage(params) {
    return { evid: 818, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'filtersFindMoreClick' event (evid: 692)
 *
 * Event description: filters.find_more.click
 *
 * @param {filtersFindMoreClickParams} params - The parameters for this event
 * @property {string} clickOrigin - filter_find_more / filter_wide
 * @property {string} filterCategory - category that was filtered when user use filter
 * @property {string} layout - .
 * @property {GUID} msid - .
 * @property {string} origin - .
 * @property {string} publicMediaRoot - .
 * @property {string} sessionId - .
 * @property {string} source - .
 * @property {string} tabName - site_files / my_favorites / free / shutterstock
 * @return {LogObject<filtersFindMoreClickParams>} LogObject<filtersFindMoreClickParams>
 */
export function filtersFindMoreClick(params) {
    return { evid: 692, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'mediaManagerExceedingQuotaPopUpOpened' event (evid: 655)
 *
 * Event description: Your storage is full pop up opened
 *
 * @param {mediaManagerExceedingQuotaPopUpOpenedParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} origin - origin
 * @property {string} pageType - new/existing_one_site/existing_multiple_site
 * @property {string} publicMediaRoot
 * @property {string} sessionId - sessionId
 * @property {string} source - source
 * @property {string} tabName - the tab the manager was opened
 * @return {LogObject<mediaManagerExceedingQuotaPopUpOpenedParams>} LogObject<mediaManagerExceedingQuotaPopUpOpenedParams>
 */
export function mediaManagerExceedingQuotaPopUpOpened(params) {
    return { evid: 655, src: 26, endpoint: 'media-manager-g6', params: params };
}
/**
 * A function to create a log object for the 'addMediaImportClick' event (evid: 623)
 *
 * Event description: User clicks on Import / Import selection button - shoot for every file
 *
 * @param {addMediaImportClickParams} params - The parameters for this event
 * @property {boolean} batch - several files in one import
 * @property {string} batchId - batch id
 * @property {number} batchSize - amount of files
 * @property {string} correlationId - id to find one upload process
 * @property {string} fileFormat - file extension
 * @property {string} layout - layout
 * @property {string} mediaType - image / video / audio / doc / folder / mixed
 * @property {GUID} msid
 * @property {string} origin
 * @property {string} publicMediaRoot
 * @property {string} sessionId
 * @property {string} source
 * @property {string} tabName - tabName
 * @property {string} target - upload / facebook / drive / dropbox / wix_sites / url / upload_drag_and_drop / vimeo / etc
 * @return {LogObject<addMediaImportClickParams>} LogObject<addMediaImportClickParams>
 */
export function addMediaImportClick(params) {
    return { evid: 623, src: 26, endpoint: 'media-manager-g6', params: params };
}
//# sourceMappingURL=index.js.map